// 教育局路由

export default  [
	/**
	 *** 首页
	 **/
	{
		name: '首页概览',
		path: '/homePageEducation',
		// component: () => import('@/views/education/homePage/index.vue'),
		component: () => import('@/views/homePage/index.vue'),
	},
	/**
	 *** 课程管理
	 **/
	// 区级
	{
		name: '课程审核',
		path: '/education/courseManager/area/courseCheck',
		component: () => import('@/views/education/courseManager/area/courseCheck/index.vue'),
	},
	{
		name: '材料审核',
		path: '/education/courseManager/area/materialCheck',
		component: () => import('@/views/education/courseManager/area/materialCheck/index.vue'),
	},
	{
		name: '试课审核',
		path: '/education/courseManager/area/trialClassCheck',
		component: () => import('@/views/education/courseManager/area/trialClassCheck/index.vue'),
	},
	{
		name: '课程管理',
		path: '/education/courseManager/area/courseManager',
		component: () => import('@/views/education/courseManager/area/courseManager/index.vue'),
	},
	{
		name: '材料管理',
		path: '/education/courseManager/area/materialManager',
		component: () => import('@/views/education/courseManager/area/materialManager/index.vue'),
	},
	{
		name: '五育课程类目设置',
		path: '/education/courseManager/teachingSetting',
		component: () => import('@/views/education/courseManager/category/categorySetting/index.vue'),
	},
	{
		name: '素质课程类目设置',
		path: '/education/courseManager/qualitySetting',
		component: () => import('@/views/education/courseManager/category/categorySetting/index.vue'),
	},
	{
		name: '类目展示设置',
		path: '/education/courseManager/showSetting',
		component: () => import('@/views/education/courseManager/category/showSetting/index.vue'),
	},
	// 市级
	// 省级
	{
		name: '课程监管',
		path: '/education/courseManager/city/courseSupervise',
		component: () => import('@/views/education/courseManager/city/courseSupervise/index.vue'),
	},
	{
		name: '材料监管',
		path: '/education/courseManager/city/materialSupervise',
		component: () => import('@/views/education/courseManager/city/materialSupervise/index.vue'),
	},

	/**
	 *** 机构管理
	 **/
	{
		name: '校外培训机构',
		path: '/education/mechanism/outSchoolUnit',
		component: () => import('@/views/education/mechanism/outSchoolUnit/index.vue'),
	},
	{
		name: '机构管理',
		path: '/education/mechanism/orginManagement',
		component: () => import('@/views/education/mechanism/orginManagement/index.vue'),
	},
	{
		name: '监管账户',
		path: '/education/mechanism/regulatoryAccount',
		component: () => import('@/views/education/mechanism/regulatoryAccount/index.vue'),
	},
	{
		name: '在职从业人员',
		path: '/education/mechanism/onJob',
		component: () => import('@/views/education/mechanism/personnelManagement/onJob.vue'),
	},
	{
		name: '离职从业人员',
		path: '/education/mechanism/outJob',
		component: () => import('@/views/education/mechanism/personnelManagement/outJob.vue'),
	},
	{
		name: '在职从业人员',
		path: '/education/mechanism/blacklist',
		component: () => import('@/views/education/mechanism/personnelManagement/blacklist'),
	},
	/**
	 *** 资金管理
	 **/
	 {
		name: '交易记录',
		path: '/education/moneyManager/transactionRecord',
		component: () => import('@/views/education/moneyManager/transactionRecord/index.vue'),
	},
	{
		name: '资金管理',
		path: '/education/moneyManager/moneyAdministration',
		component: () => import('@/views/education/moneyManager/moneyAdministration/index.vue'),
	},
	{
		name: '课酬管理',
		path: '/education/moneyManager/classPay',
		component: () => import('@/views/education/moneyManager/classPay/index.vue'),
	},
	/**
	 *** 统计分析
	 **/
	 {
		name: '学校排课统计',
		path: '/education/statistical/outCourse',
		component: () => import('@/views/education/statistical/outCourse/index.vue'),
	},
	{
		name: '学生托管统计',
		path: '/education/statistical/studentHosting',
		component: () => import('@/views/education/statistical/studentHosting/index.vue'),
	},
	{
		name: '学校开课统计',
		path: '/education/statistical/schoolClasses',
		component: () => import('@/views/education/statistical/schoolClasses/index.vue'),
	},
	{
		name: '机构课程统计',
		path: '/education/statistical/institutionsCourseStatistics',
		component: () => import('@/views/education/statistical/institutionsCourseStatistics/index.vue'),
	},
	{
		name: '课程评价统计',
		path: '/education/statistical/courseEvaluation',
		component: () => import('@/views/education/statistical/courseEvaluation/index.vue'),
	},
	 /**
	 *** 风险预警
	 **/
	 {
		name: '投诉预警',
		path: '/education/riskWarning/complaint',
		component: () => import('@/views/education/riskWarning/complaint/index.vue'),
	},
	{
		name: '人员预警',
		path: '/education/riskWarning/personnel',
		component: () => import('@/views/education/riskWarning/personnel/index.vue'),
	},
	{
		name: '评价预警',
		path: '/education/riskWarning/evaluate',
		component: () => import('@/views/education/riskWarning/evaluate/index.vue'),
	},
	{
		name: '风险直送',
		path: '/education/riskWarning/riskSend',
		component: () => import('@/views/education/riskWarning/riskSend/index.vue'),
	},
	 /**
	 *** 运营管理
	 **/
	{
		name: '评价管理',
		path: '/education/operatingManager/courseEvaluation',
		component: () => import('@/views/education/operatingManager/courseEvaluation/index.vue'),
	},
	{
		name: '订单管理',
		path: '/education/operatingManager/orderManager/order',
		component: () => import('@/views/education/operatingManager/orderManager/order/index.vue'),
	},
	{
		name: '退费管理',
		path: '/education/operatingManager/orderManager/refund',
		component: () => import('@/views/education/operatingManager/orderManager/refund/index.vue'),
	},
	 /**
	 *** 作业管理
	 **/
	 {
		name: '作业管理情况',
		path: '/education/task/home',
		component: () => import('@/views/education/task/home/index.vue'),
	},
	 /**
	 *** 延时课表
	 **/
	 {
		name: '延时课表',
		path: '/tableClass',
		component: () => import('@/views/education/classTable/index.vue'),
	},
];

